/**
 * @flow
 * @relayHash 5adfaf645a24a3400a32dd2eb10b11f4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignInInput = {|
  namespace: string,
  email: any,
  password: string,
|};
export type OperatorSignInMutationVariables = {|
  input: SignInInput
|};
export type OperatorSignInMutationResponse = {|
  +signIn: {|
    +user: {|
      +id: string
    |}
  |}
|};
export type OperatorSignInMutation = {|
  variables: OperatorSignInMutationVariables,
  response: OperatorSignInMutationResponse,
|};
*/


/*
mutation OperatorSignInMutation(
  $input: SignInInput!
) {
  signIn(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SignInInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "signIn",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignInPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "OperatorSignInMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "OperatorSignInMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "OperatorSignInMutation",
    "id": null,
    "text": "mutation OperatorSignInMutation(\n  $input: SignInInput!\n) {\n  signIn(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6492ed4a3c748ada2f47ca398867c14b';
module.exports = node;
